<template src="./progress-bar.html"></template>

<script lang="ts">
export default {
  data() {
    return {}
  },
  props: {
    minValue: {
      type: Number,
      default: 0
    },
    maxValue: { type: Number },
    value: { type: Number }
  },
  computed: {
    progressPercent() {
      if (this.maxValue) {
        return ((this.value - this.minValue) / (this.maxValue - this.minValue)) * 100
      }
      return 0
    },
    progressStyles() {
      return { width: `${this.progressPercent}%` }
    }
  }
}
</script>

<style lang="scss" src="./progress-bar.scss"></style>
